import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { DatasourceTableSettingsNavigationsInterface } from '../../model';

@Component({
  selector: 'y42-sub-navigation',
  templateUrl: './sub-navigation.component.html',
  styleUrls: ['./sub-navigation.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SubNavigationComponent {
  @Input() navigationType!: DatasourceTableSettingsNavigationsInterface;
  @Input() isBig = false;
  @Output() navigationClicked: EventEmitter<void> = new EventEmitter();
}
